import React from "react";
import { withRouter } from "react-router-dom";

import ProfileContext from "./ProfileContext";

const withProfile = Component => {
  class WithProfile extends React.Component {
    render() {
      return (
        <ProfileContext.Consumer>
          {profile => (
            <Component {...this.props} profile={profile ? profile : null} />
          )}
        </ProfileContext.Consumer>
      );
    }
  }

  return withRouter(WithProfile);
};

export default withProfile;



// WEBPACK FOOTER //
// ./src/utils/withProfile.js